export function roleLabel(role: string): string {
  const map: Record<string, string> = {
    gestor_dados: "Gestor de Dados/Automações",
    gestor_projetos: "Gestor de Projetos",
  };
  return map[role] || role.replace(/_/g, " ");
}

export const STATUS_LABEL: Record<string, string> = {
  in_progress: "Em andamento", submitted: "Enviado", graded: "Corrigido (draft)",
  reviewed: "Finalizado", abandoned: "Abandonado",
};
export const STATUS_BADGE: Record<string, string> = {
  in_progress: "badge-info", submitted: "badge-warning", graded: "badge-neutral",
  reviewed: "badge-success", abandoned: "badge-danger",
};
